<template>
	<div class="scene-wrapper">
		<Enzo
			ref="enzo"
			v-bind="{ ...$attrs, cost, formattedCost }"
			:transitions="transitions"
			:buttons="buttons"
			:content="request_dialogue"
		/>
	</div>
</template>

<script>
import Enzo from '@/components/partials/Enzo';
import { currencyFormatter } from "@/lib/formatters";


export default {
	name: 'Curveball',
	components: {
		Enzo,
	},
	props: {
		title: { // Included to prevent default HTML title popup
			type: String,
		},
		request_dialogue: {
			type: String,
			required: true,
		},
		accept_button_text: {
			type: String,
			required: true,
		},
		deny_button_text: {
			type: String,
			required: false,
		},
		return_if_denied: {
			type: Boolean,
			required: true,
		},
		cost: {
			type: Number,
			required: true,
		},
	},
	computed: {
		formattedCost() {
			return currencyFormatter.format(this.cost);
		},
		transitions() {
			return {
				entering: "speaking",
				...(this.return_if_denied && { denied: "entering" }),
			};
		},
		buttons() {
			const buttons = [{ text: this.accept_button_text, action: this.accept }];

			if (this.deny_button_text) {
				buttons.unshift({ text: this.deny_button_text, action: this.deny });
			}

			return buttons;
		},
	},
	methods: {
		accept() {
			this.$refs.enzo.pushState("accepted", () => this.$router.push('/game/curveball/accept'));
			this.$store.dispatch("sound/fx/play", { id: "stinger_positive" });
		},
		deny() {
			this.$refs.enzo.pushState("denied", () => this.$router.push('/game/curveball/deny'));
			this.$store.dispatch("sound/fx/play", { id: "stinger_negative" });
		},
	},
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/game/scenes/Curveball.vue